/**
 * Copyright Mántum All Rights Reserved.
 */
import { lazy } from 'react';

export const DataGrid = lazy(() => {
    return import('@mantum/kanela-react-datagrid-adapter');
});
